import * as Types from './types.generated';

import gql from 'graphql-tag';
import { AssetFieldsFragmentDoc } from './fragments/asset.generated';
import { SeoFieldsFragmentDoc } from './components/componentSeo.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AcademyArticleOverviewFieldsFragment = { __typename: 'PageAcademyArticle', title?: string | null, urlSlug?: string | null, overviewTitle?: string | null, overviewDescription?: string | null, overviewImage?: { __typename: 'Asset', title?: string | null, url?: string | null } | null, readingTime?: { __typename: 'ComponentArticleReadingTime', min?: number | null, max?: number | null } | null };

export type AcademyArticleCategoryFieldsFragment = { __typename: 'PageAcademyCategory', title?: string | null, description?: string | null, urlSlug?: string | null, childCategoriesCollection?: { __typename: 'PageAcademyCategoryChildCategoriesCollection', items: Array<{ __typename: 'PageAcademyCategory', title?: string | null } | null> } | null };

export type AcademyPopularGameFieldsFragment = { __typename: 'PageGame', title?: string | null, urlSlug?: string | null, categories?: Array<string | null> | null, sys: { __typename: 'Sys', firstPublishedAt?: any | null }, mainImage?: { __typename: 'Asset', title?: string | null, description?: string | null, url?: string | null } | null, gameTagsCollection?: { __typename: 'PageGameGameTagsCollection', items: Array<{ __typename: 'ComponentGameTag', name?: string | null } | null> } | null };

export type ArticleOverviewPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ArticleOverviewPageQuery = { __typename: 'Query', pageAcademyOverviewCollection?: { __typename: 'PageAcademyOverviewCollection', items: Array<{ __typename: 'PageAcademyOverview', title?: string | null, description?: string | null, metaTitle?: string | null, metaDescription?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, keywords?: string | null, ogImage?: { __typename: 'Asset', title?: string | null, description?: string | null, width?: number | null, height?: number | null, url?: string | null } | null, linkedSeoTags?: { __typename: 'ComponentSeoTags', title?: string | null, description?: string | null, keywords?: string | null, noFollow?: boolean | null, noIndex?: boolean | null } | null, sys: { __typename: 'Sys', firstPublishedAt?: any | null, publishedAt?: any | null }, popularGamesCollection?: { __typename: 'PageAcademyOverviewPopularGamesCollection', items: Array<{ __typename: 'PageGame', title?: string | null, urlSlug?: string | null, categories?: Array<string | null> | null, sys: { __typename: 'Sys', firstPublishedAt?: any | null }, mainImage?: { __typename: 'Asset', title?: string | null, description?: string | null, url?: string | null } | null, gameTagsCollection?: { __typename: 'PageGameGameTagsCollection', items: Array<{ __typename: 'ComponentGameTag', name?: string | null } | null> } | null } | null> } | null } | null> } | null, pageAcademyCategoryCollection?: { __typename: 'PageAcademyCategoryCollection', items: Array<{ __typename: 'PageAcademyCategory', title?: string | null, description?: string | null, urlSlug?: string | null, childCategoriesCollection?: { __typename: 'PageAcademyCategoryChildCategoriesCollection', items: Array<{ __typename: 'PageAcademyCategory', title?: string | null } | null> } | null } | null> } | null };

export const AcademyArticleOverviewFieldsFragmentDoc = gql`
    fragment academyArticleOverviewFields on PageAcademyArticle {
  title
  urlSlug
  overviewTitle
  overviewImage {
    title
    url
  }
  overviewDescription
  readingTime {
    min
    max
  }
}
    `;
export const AcademyArticleCategoryFieldsFragmentDoc = gql`
    fragment academyArticleCategoryFields on PageAcademyCategory {
  title
  description
  urlSlug
  childCategoriesCollection(limit: 15) {
    items {
      title
    }
  }
}
    `;
export const AcademyPopularGameFieldsFragmentDoc = gql`
    fragment academyPopularGameFields on PageGame {
  sys {
    firstPublishedAt
  }
  title
  urlSlug
  mainImage {
    title
    description
    url
  }
  categories
  gameTagsCollection {
    items {
      name
    }
  }
}
    `;
export const ArticleOverviewPageDocument = gql`
    query articleOverviewPage {
  pageAcademyOverviewCollection(limit: 1) {
    items {
      title
      description
      metaTitle
      metaDescription
      ogImage {
        ...assetFields
      }
      noFollow
      noIndex
      keywords
      linkedSeoTags {
        ...seoFields
      }
      sys {
        firstPublishedAt
        publishedAt
      }
      popularGamesCollection(limit: 4) {
        items {
          ...academyPopularGameFields
        }
      }
    }
  }
  pageAcademyCategoryCollection(
    where: {childCategoriesCollection_exists: true}
    order: overviewOrder_ASC
  ) {
    items {
      title
      description
      urlSlug
      childCategoriesCollection(limit: 1) {
        items {
          title
        }
      }
    }
  }
}
    ${AssetFieldsFragmentDoc}
${SeoFieldsFragmentDoc}
${AcademyPopularGameFieldsFragmentDoc}`;